import i18n from "i18next";

import "../i18n";
import { proBonoDetail } from "../constants/actionTypes";

const defaultState = {
  error: null,
  errorStatus: null,
  lead: {},
  loading: true,
  success: {
    hideLead: false,
    takeLead: false,
    unhideLead: false
  }
};

export default function proBonoDetailReducer(state = defaultState, action) {
  const { type, payload, status } = action;

  switch (type) {
    case proBonoDetail.SET_LOADING:
      return {
        ...state,
        loading: true
      };

    case proBonoDetail.RESET_SUCCESS:
      return {
        ...state,
        success: { ...state.success, [payload]: false }
      };

    case proBonoDetail.RESET_ALL_SUCCESS:
      return {
        ...state,
        success: { ...defaultState.success }
      };

    case proBonoDetail.RESET_ERROR:
      return {
        ...state,
        error: null
      };

    // GROWTH-6615: success flags are owned by the action flows, RESET_SUCCESS and CLEAR_LEAD.
    // A refetch must not clear them: the toast timers depend on the flag staying set.
    case proBonoDetail.GET_LEAD:
      return {
        ...state,
        lead: payload,
        loading: false,
        error: null,
        errorStatus: null
      };

    // GROWTH-7960: the HTTP status tells a request that is gone (404) from one that failed to load.
    case proBonoDetail.GET_LEAD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        errorStatus: status || null
      };

    case proBonoDetail.HIDE_LEAD:
      return {
        ...state,
        loading: false,
        lead: { ...state.lead, hidden: true, hide: 1 },
        success: { ...state.success, hideLead: i18n.t("dashboard_probono_detail_success_hidden") }
      };

    case proBonoDetail.HIDE_LEAD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    // Clearing hideLead cancels a hide redirect that is still pending: an unhide stays on the lead.
    case proBonoDetail.UNHIDE_LEAD:
      return {
        ...state,
        loading: false,
        lead: { ...state.lead, hidden: false, hide: 0 },
        success: { ...state.success, hideLead: false, unhideLead: i18n.t("dashboard_probono_detail_success_restored") }
      };

    case proBonoDetail.UNHIDE_LEAD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case proBonoDetail.TAKE_LEAD:
      return {
        ...state,
        loading: false,
        success: { ...state.success, takeLead: i18n.t("dashboard_probono_detail_success_accepted") }
      };

    case proBonoDetail.TAKE_LEAD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    // Runs when the page unmounts or the lead changes, so a toast or error from one visit
    // cannot show up on the next one.
    case proBonoDetail.CLEAR_LEAD:
      return {
        ...state,
        lead: {},
        error: null,
        errorStatus: null,
        success: { ...defaultState.success }
      };

    default:
      return state;
  }
}
